module.exports = __webpack_public_path__ + "img/globe.a792c966.png";